import React from "react";
import headerLayoutWrapper from "../hoc/headerLayoutWrapper";
const Loading = () => {
  return (
    <div
      className="d-flex align-items-center justify-content-center p-5"
      style={{ height: "100vh" }}
    >
      <div className="spinner-border text-secondary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Loading;
// export default headerLayoutWrapper(Loading);
